import { call, put, takeLatest } from 'redux-saga/effects';
import { getNotificationsSettings, saveNotificationsSettings } from '../../services/API';
import {
  actionTypes,
  getNotificationsSettingsError,
  getNotificationsSettingsSuccess,
  saveNotificationsSettingsSuccess,
  saveNotificationsSettingsError,
} from './actions';

function* getNotificationsSettingsSaga({ payload }) {
  const { isOk, data, error } = yield call(getNotificationsSettings, payload);
  yield put(isOk ? getNotificationsSettingsSuccess(data) : getNotificationsSettingsError(error));
}

function* saveNotificationsSettingsSaga({ payload }) {
  const settings = payload.toJSON();
  const { isOk, error } = yield call(saveNotificationsSettings, settings);
  yield put(
    isOk ? saveNotificationsSettingsSuccess(settings) : saveNotificationsSettingsError(error),
  );
}

export default function* profileNotificationsSaga() {
  yield takeLatest(actionTypes.GET_NOTIFICATIONS_SETTINGS, getNotificationsSettingsSaga);
  yield takeLatest(actionTypes.SAVE_NOTIFICATIONS_SETTINGS, saveNotificationsSettingsSaga);
}
